import { PhoneNumberUtil } from 'google-libphonenumber';
import { VALIDATION_CONSTANTS, USER_MESSAGES } from '../../constants/authConstants';

const phoneUtil = PhoneNumberUtil.getInstance();

// ============================================
// PHONE VALIDATION
// ============================================

/**
 * Validates a phone number
 * @param {string} phone - The phone number with country code (e.g., "33612345678" or "+33612345678")
 * @returns {boolean} - True if the number is valid, false otherwise
 */
export const isPhoneValid = (phone) => {
  if (!phone || phone.length < 3) return false;
  try {
    const formattedPhone = phone.startsWith('+') ? phone : `+${phone}`;
    const phoneNumber = phoneUtil.parseAndKeepRawInput(formattedPhone);
    return phoneUtil.isValidNumber(phoneNumber);
  } catch (error) {
    return false;
  }
};

/**
 * Formats a phone number in international format
 * @param {string} phone - The phone number with country code (e.g., "33612345678" or "+33612345678")
 * @returns {string} - The formatted number (e.g., "+33 6 12 34 56 78")
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  try {
    const formattedPhone = phone.startsWith('+') ? phone : `+${phone}`;
    const phoneNumber = phoneUtil.parseAndKeepRawInput(formattedPhone);
    const PNF = require('google-libphonenumber').PhoneNumberFormat;
    return phoneUtil.format(phoneNumber, PNF.INTERNATIONAL);
  } catch (error) {
    return phone;
  }
};

// ============================================
// PASSWORD VALIDATION
// ============================================

/**
 * Validates password length
 * @param {string} password - Password to validate
 * @returns {Object} - Validation result with success boolean and message
 */
export const validatePasswordLength = (password) => {
  if (!password || password.length < VALIDATION_CONSTANTS.MIN_PASSWORD_LENGTH) {
    return {
      success: false,
      message: USER_MESSAGES.PASSWORD_TOO_SHORT,
    };
  }
  return { success: true };
};

/**
 * Validates password confirmation match
 * @param {string} password - Original password
 * @param {string} confirmPassword - Confirmation password
 * @returns {Object} - Validation result with success boolean and message
 */
export const validatePasswordMatch = (password, confirmPassword) => {
  if (password !== confirmPassword) {
    return {
      success: false,
      message: USER_MESSAGES.PASSWORDS_DONT_MATCH,
    };
  }
  return { success: true };
};

/**
 * Validates both password length and confirmation match
 * @param {string} password - Original password
 * @param {string} confirmPassword - Confirmation password
 * @returns {Object} - Validation result with success boolean and message
 */
export const validatePasswordComplete = (password, confirmPassword) => {
  const matchValidation = validatePasswordMatch(password, confirmPassword);
  if (!matchValidation.success) {
    return matchValidation;
  }

  const lengthValidation = validatePasswordLength(password);
  if (!lengthValidation.success) {
    return lengthValidation;
  }

  return { success: true };
};


